import React from 'react';
import { Typography, Grid, Link, Box, Button } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { TemplateWizard } from '../TemplateWizard/TemplateWizard';
import {
  InfoCard,
  Header,
  Page,
  Content,
  ContentHeader,
  HeaderLabel,
  SupportButton,
} from '@backstage/core-components';

const useStyles = makeStyles(theme => ({
  linkItem: {
    marginBottom: theme.spacing(2),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  linkLabel: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  surveyWidget: {
    width: '100%',
    minHeight: '600px',
    '& iframe': {
      width: '100%',
      minHeight: '600px',
      border: 'none',
    },
  },
}));

export interface ServerLink {
  label: string;
  url: string;
}

export interface GenericAccessPageProps {
  serviceName: string;
  title: string;
  supportText: string;
  serverLinks: ServerLink[][];
  formUrl?: string;
  formTitle?: string;
  templateRef?: string;
}

export const GenericAccessPage: React.FC<GenericAccessPageProps> = ({
  serviceName,
  title,
  supportText,
  serverLinks,
  formUrl,
  formTitle = 'Request Details',
  templateRef,
}) => {
  const classes = useStyles();
  
  return (
    <Page themeId="tool">
      <Header title="Welcome to our Self Service Portal 🚀" subtitle="Get Access to our resources and services">
        <HeaderLabel label="Owner" value="oliver.paul" />
        <HeaderLabel label="Lifecycle" value="Alpha" />
      </Header>
      <Content>
        <ContentHeader title={title}>
          <SupportButton>{supportText}</SupportButton>
        </ContentHeader>
        <Grid container spacing={3} direction="column">
          <Grid item>
            <InfoCard title={`${serviceName} Server URLs`}>
              <Grid container spacing={3}>
                {serverLinks.map((column, columnIndex) => (
                  <Grid key={columnIndex} item xs={12} md={6}>
                    {column.map((link, linkIndex) => (
                      <Box key={linkIndex} className={classes.linkItem}>
                        <Typography variant="body2" className={classes.linkLabel}>
                          {link.label}
                        </Typography>
                        <Link
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={classes.link}
                        >
                          {link.url}
                        </Link>
                      </Box>
                    ))}
                  </Grid>
                ))}
              </Grid>
            </InfoCard>
          </Grid>
          <Grid item xs={12}>
            <InfoCard title={formTitle}>
              {templateRef ? (
                <TemplateWizard templateRef={templateRef} />
              ) : formUrl?.startsWith('/') ? (
                <Box display="flex" justifyContent="center" p={4}>
                  <Button
                    component={RouterLink}
                    to={formUrl}
                    variant="contained"
                    color="primary"
                    size="large"
                  >
                    Open Request Form
                  </Button>
                </Box>
              ) : formUrl ? (
                <Box className={classes.surveyWidget}>
                  <iframe
                    src={formUrl}
                    title={formTitle}
                    style={{
                      width: '100%',
                      height: '600px',
                      border: 'none',
                    }}
                  />
                </Box>
              ) : null}
            </InfoCard>
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};

